jQuery(function($){

   sessionStorage.setItem("cartCount", 0);
  
  $(document).ready(function(){
    $(window).scroll(function() {
      if ($(window).scrollTop() > 500 && $(window).scrollTop() < 2800) {
        $('#stickyTop').show();
      }
      else {
        $('#stickyTop').hide();
      }
    });
	
/* 	$('.cartIcon a').click(function(){
     $('body').css("overflow", "hidden");
      $('.drawerBackdrop').css("display", "block");
      $('.cartView').addClass('cartShow');

      $('.closeCart,.drawerBackdrop').click(function(){
       $('.cartView').removeClass('cartShow');
       $('.drawerBackdrop').css("display", "none");
        $('body').css("overflow", "auto");
      })
     });
	 
	 loadCart(null,'no');  */
  });


  
  var buyNow = $('.btn-buy-product');
  buyNow && buyNow.on('click', function (evt) {
	  // var element = document.getElementById("variant-selector");
	  
	    var offsetHeight = $("#scroll-header-text").offset().top;
	   if( $('#scroll-point').css('display')=='none') {
			offsetHeight = offsetHeight - 86;    
		}
		
$('html, body').animate({
        scrollTop: offsetHeight
      }
                              , 1700, function(){
      }
                             );
							 
							 
							 
 
							 
// element.scrollIntoView({behavior: "smooth", alignToTop : true});
   /*  evt.preventDefault();
	var selected_id = $(buyNow).data('id');
	console.log(selected_id);
	   // jQuery.ajax({
			// type: 'POST',
			// url: '/cart/update.js', 
			// data: '{ updates: {'+ selected_id+': 1 } }', 
			// dataType: 'json',
			// success: function() { 
				// location.href = '/checkout';
				// window.testGlobalBeforeReact(0);
			// }
		  // });
  
  var dateObject = '{ "quantity": 0, "id": '+ selected_id +' }';
	  jQuery.ajax({
		 type: 'post',
		 url: '/cart/change.js', 
		 data: JSON.parse(dateObject), 
		 dataType: 'json',
		 success: function() { 
					  jQuery.ajax({
						 type: 'post',
						 url: '/cart/add.js', 
						 data: JSON.parse('{ "items":[ { "id": '+ selected_id +' } ]}'), 
						 dataType: 'json',
						 success: function() { 
							location.href = '/checkout';
							 window.testGlobalBeforeReact(0);
							 }
					   });
			 }
	   });
 */
 
    // Use the ajax API to add the product to the cart here. Once that request succeeds, then do this:
    
    
  });
  
  
  function AddItemToCart(e, id){
	 var quantityNum = ($(".quantity-num") == null || $(".quantity-num").length == 0) || $(".quantity-num")[0].value == "" ? 1 : $(".quantity-num")[0].value;
	 
	 //  console.log(id);
     $.ajax({
      type: 'POST', 
       url: '/cart/add.js',
      dataType: 'json', 
       data: {id: id,quantity: quantityNum},
       success: function(data){
			// console.log(data.price);
        
           setTimeout(function(){ 
            //$('.loader').hide(); 
             loadCart(e,'yes');  
             //fbq('track', 'AddToCart', { value: parseInt(data.price) / 100,currency: 'USD'});  
           }, 500);
        
        
      },
     });
    
   }
   
   function updateCart(e,variantId,qty){    
    $.post('/cart/change.js', 
           { 
      
            quantity: qty, 
            id: variantId,
                function(){
                 setTimeout(function(){ loadCart(e,'yes');  }, 250);
                }           
           
           });
  }
  
 /*  $(document).on('click', '.btn-minus', function(e){
    var id = $(this).data('id');
        var oldQty = $('#itemCount'+id).val();
        var newQty = parseInt(oldQty) - parseInt(1);
         updateCart(e,id,newQty);   
       //console.log(newQty);
  });
  
 
  
  //Plus button functionality script
  
  $(document).on('click', '.btn-plus', function(e){
        var id = $(this).data('id');
        var oldQty = $('#itemCount'+id).val();
        var newQty = parseInt(oldQty) + parseInt(1);
         updateCart(e,id,newQty);   
       //console.log(newQty);
  });
  
  $(document).on('click', '.addToCartLink', function(e){
      
    //console.log($(this).data('id'));
    //console.log($(this).attr('data-id'));
    AddItemToCart(e, $(this).attr('data-variantid'));
    //loadCart(e);
                 
  });
							 
	 
	 
	  $(document).on('click', '.btnShopping', function(e){
    //window.location.href = 'https://mia-corbusier.myshopify.com/pages/watch/';
      $('.closeCart').trigger('click');
  });
   $(document).on('click', '.btnShoppingContinue', function(e){
    //window.location.href = 'https://mia-corbusier.myshopify.com/pages/watch/';
      $('.closeCart').trigger('click');
  }); */
  
  
  function loadCart(e,isShow){
	
    $.get(
    
      '/cart.js',
      function(res){
        //console.log(res);
        var itemCount = res.item_count;
        if(itemCount > 0){
          var html = '';
          var total = 0;
          var cartItems = res.items;
						 
			if(typeof freeProduct_1 !== "undefined"){
				freeProduct_1(cartItems, e, isShow, loadCart);
			}
			
			$.each(cartItems, function(k, v) {
					  console.log(cartItems);
					 html+= '<div class="cartListItem d-flex">\
					 <div><img class="mr-2" width="100px" src="'+cartItems[k]["featured_image"]["url"]+'"></div>\
					 <div class="w-100">\
					 <h4>'+cartItems[k]["product_title"]+'</h4>\
					 <p>'+(cartItems[k]["variant_title"] == null || cartItems[k]["variant_title"].length == 0 ? '' : cartItems[k]["variant_title"])+'</p>\
					 <div class="d-flex quantity align-items-center justify-content-between">\
					<div class="qty-button-container">\
						<div class="quantity">\
							<div class="js-qty">\
								<button type="button" class="js-qty__adjust--minus btn-minus" data-id="'+cartItems[k]["id"]+'"><span><div class="minusCardButton"></div></span><span class="fallback-text"></span></button>\
								 <input type="text" id="itemCount'+cartItems[k]["id"]+'" value="'+cartItems[k]["quantity"]+'" placeholder="" aria-label="" aria-describedby="basic-addon1">\
								<button type="button" class="js-qty__adjust--plus btn-plus" data-id="'+cartItems[k]["id"]+'"><span><div class="plusCardButton"></div></span><span class="fallback-text">+</span></button>\
							</div>\
						</div>\
					</div>';   
					 
 if(cartItems[k]["discounts"].length > 0){
			   html+= '<h5 style="text-decoration: line-through; color: #717171;">$'+((parseInt(cartItems[k]["price"])*parseInt(cartItems[k]["quantity"])) / 100)+'</h5></div><div class="d-flex py-1 quantity align-items-center justify-content-between">\
			   <h5 class="mx-0" style="color: #717171;"><i aria-hidden="true" class="fa fa-tag mirror-x" style="margin-right: 5px"></i>(-$'+cartItems[k]["total_discount"]/100+')</h5><h5>$'+(parseInt(cartItems[k]["line_price"]) / 100) +'</h5></div></div></div>';           
           
			 }else{
			   html+= '<h5 >$'+((parseInt(cartItems[k]["price"])*parseInt(cartItems[k]["quantity"])) / 100)+'</h5></div></div></div>';           
           
			 }					 
					 // total= parseInt(total) + ((parseInt(cartItems[k]["price"])*parseInt(cartItems[k]["quantity"])) / 100); 
					});
				
				 total= res.total_price/100;
				if (document.location.pathname.indexOf("/product") >= 0) {
					html+='<a href="/" class=" back-button btnShoppingContinue"><h6 class="py-4 text-center">Continue Shopping</h6></a>';
						
						
					// if (document.location.pathname.indexOf("/products/") >= 0) {
						
					}else{
						html+='<a class=" back-button btnShoppingContinue"><h6 class=" py-4 text-center">Continue Shopping</h6></a>';
					}
				
				  $('.cartList').html(html);
				  if(isShow == 'yes'){$('.cartItem a').trigger('click');}
				  $('.cartTotal h4 i').text('$'+parseFloat(total));
				  $('.cartItem a .svg-cart-icon-blue').show();
				  $('.cartItem a .svg-cart-icon').hide();
				  $('.cartItem a span').text(itemCount);
				  
				  sessionStorage.setItem("cartCount", itemCount);
				  if($('.btnCheckout').length == 0){
					$('.btnShopping').remove();
					$('.cartTotal').append('<button  type="submit" name="checkout" class="btn btn-block btnCheckout">PROCEED TO CHECKOUT</button>');
				  }

        }else{
          $('.btnCheckout').remove();
          $('.cartTotal h4 i').text('$0');
		  $('.cartItem a .svg-cart-icon-blue').hide();
		  $('.cartItem a .svg-cart-icon').show();
          $('.cartItem a span').text(0);
          sessionStorage.setItem("cartCount", 0);
          var html = '<strong>Your cart is empty.</strong>';
          $('.cartList').html(html);
          if($('.btnShopping').length == 0){

           	if (document.location.pathname.indexOf("/yveskardier") >= 0) {
							 $('.cartTotal').append('<a class="btn btn-block btnShopping">Continue Shopping</a>');
				
						}else{
						$('.cartTotal').append('<a href="/" class="btn btn-block btnShopping">Continue Shopping</a>');}
          }
        }

      }, 'json'
    
    );
    
  }

  /*on scroll sticky choose product */
  // $(window).scroll(function () {
    // var scroll = $(window).scrollTop();
    // if (scroll >= 150) {
      // $(".cuponWrap ").addClass('cuponWrapSticky');
    // } else {
      // $(".cuponWrap").removeClass('cuponWrapSticky'); 
    // }
  // });
  
$(document).ready(function() {
    var firstArray = ['James','Mary','Robert','Jennifer','Michael','Elizabeth','Thomas','Nancy','Charles','Margaret','David','Ashley','Benjamin','Frank','Hannah','Karen','Lucy','Oscar','Peter','Rachel','Steve','Vanessa'];
    var lastArray = ['A','B','C','D','E','F','G','H','K','L','M','N','O','P','R','S','T','V','W','Y'];
    var locationArray = ['Birmingham, AL','Phoenix, AZ','Little Rock, AR','Los Angeles, CA','Denver, CO','Wilmington, DE','Washington D.C.','Jacksonville, FL','Atlanta, GA','Boise, ID','Chicago, IL','Indianapolis, IN','Wichita, KS','Louisville, KY','New Orleans, LA','Boston, MA','Lansing, MI','Jackson, MS','Omaha, NE','Las Vegas, NV','Newark, NJ','New York, NY','Albuquerque, NM','Charlotte, NC','Columbus, OH','Oklahoma City, OK','Philadelphia, PA','Columbia, SC','Memphis, TN','Houston, TX','Salt Lake City, UT','Seattle, WA','Milwaukee, WI','Cheyenne, WY'];
	  setInterval(function(){
		var randTime = Math.floor((Math.random()*40)+5);
		$('#randTime').html(randTime);

		var firstRand = Math.floor(Math.random()*firstArray.length);
		var randFirst = firstArray[firstRand];
		$('#randFirst').html(randFirst);

		var lastRand = Math.floor(Math.random()*lastArray.length);
		var randLast = lastArray[lastRand];
		$('#randLast').html(randLast);

		var locationRand = Math.floor(Math.random()*locationArray.length);
		var randLocation = locationArray[locationRand];
		$('#randLocation').html(randLocation);

		$('#recentBox').css("opacity", "1");
		$('#recentBox').animate({'bottom': '12'}, {
		 duration: 800
		});

		setTimeout(function(){
		  $('#recentBox').animate({'bottom': '-62'}, {
		   duration: 800
		 });
	   }, 4500);

	   setTimeout(function(){
		 $('#recentBox').css("opacity", "0");
	  }, 5400);

	}, 15000);

});

});  